import React from 'react';
import './Hero.css';
import BlurText from './BlurText';
import Orb from './Orb';

const Hero = ({
  title = "Nahradte ľudský faktor, robotom ktorý nikdy nespí a nepotrebuje dovolenku",
  subtitle = "Anonymné, efektívne, bezpečné. Vaše dôveryhodné AI riešenie pre taxíky na Slovensku, vedené tímom profesionálov.",
  ctaLink = "#ako-to-funguje"
}) => {
  const handleAnimationComplete = () => {
    console.log('Animation completed!');
  };

  return (
    <section className="hero" id="domov">      
      <div className="hero-content">
        <BlurText
          text={title}
          delay={150}
          animateBy="words"
          direction="top"
          onAnimationComplete={handleAnimationComplete}
          className="hero-title"
        />
        <p className="hero-subtitle">{subtitle}</p>
        
        <div className="hero-cta">
          <a href="#ako-to-funguje" className="modern-login-btn services-btn">
            <svg 
              width="14" 
              height="14" 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              className="services-icon"
            >
              <path d="M12 2L2 7l10 5 10-5-10-5z"/>
              <path d="M2 17l10 5 10-5"/>
              <path d="M2 12l10 5 10-5"/>
            </svg>
            Služby
          </a>
        </div>
        
        <div className="ai-orb-section scroll-reveal">
          <div className="orb-wrapper">
            <Orb
              hoverIntensity={0.5}
              rotateOnHover={true}
              hue={0}
              forceHoverState={false}
            />
            <div className="ai-greeting">
              "Dobrý deň, kam to bude?"
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero; 